import { FC } from 'react';

import { useGetTherapist } from '@helpful/network';
import { Grid, Skeleton, Stack, Typography, Video } from '@wearehelpful/ui-kit';
import { useTranslation } from '@wearehelpful/ui-localization';

interface TherapistDetailsProps {
  id: string;
}

export const TherapistDetails: FC<TherapistDetailsProps> = ({ id }) => {
  const { t } = useTranslation();

  const { isSuccess, isLoading, data } = useGetTherapist(id, {});

  return (
    <Skeleton loading={isLoading} variant="article">
      {isSuccess && (
        <Stack spacing={0}>
          <Grid>
            <Grid.Row>
              <Grid.Col xs="12" lg="6">
                <Video
                  poster={data.picture}
                  video={data.video}
                  aspectRatio={1.08}
                />
              </Grid.Col>
              <Grid.Col xs="12" lg="6">
                <Stack spacing={1}>
                  <Typography variant="sub1" bold>
                    {t('forms.fullNameWithTitle', {
                      fullName: data.fullName,
                      title: data.title,
                    })}
                  </Typography>
                  <Typography variant="p2">{data.description}</Typography>
                </Stack>
              </Grid.Col>
            </Grid.Row>
          </Grid>
          {!!data.quote && (
            <Grid>
              <Grid.Row>
                <Grid.Col>
                  <Stack>
                    <Typography variant="p2">{data.quote}</Typography>
                  </Stack>
                </Grid.Col>
              </Grid.Row>
            </Grid>
          )}
          {!!data.funFact && (
            <Grid>
              <Grid.Row>
                <Grid.Col>
                  <Stack>
                    <Typography variant="sub1" bold>
                      {t('forms.funFact')}
                    </Typography>
                    <Typography variant="p2">{data.funFact}</Typography>
                  </Stack>
                </Grid.Col>
              </Grid.Row>
            </Grid>
          )}
          {!!data.therapeuticApproach && (
            <Grid>
              <Grid.Row>
                <Grid.Col>
                  <Stack>
                    <Typography variant="sub1" bold>
                      {t('forms.therapeuticApproach')}
                    </Typography>
                    <Typography variant="p2">
                      {data.therapeuticApproach}
                    </Typography>
                  </Stack>
                </Grid.Col>
              </Grid.Row>
            </Grid>
          )}
          {!!data.specializationsAndInterests && (
            <Grid>
              <Grid.Row>
                <Grid.Col>
                  <Stack>
                    <Typography variant="sub1" bold>
                      {t('forms.specializationsAndInterests')}
                    </Typography>
                    <Typography variant="p2">
                      {data.specializationsAndInterests}
                    </Typography>
                  </Stack>
                </Grid.Col>
              </Grid.Row>
            </Grid>
          )}
          {!!data.biography && (
            <Grid>
              <Grid.Row>
                <Grid.Col>
                  <Stack>
                    <Typography variant="sub1" bold>
                      {t('forms.biography')}
                    </Typography>
                    <Typography variant="p2">{data.biography}</Typography>
                  </Stack>
                </Grid.Col>
              </Grid.Row>
            </Grid>
          )}
        </Stack>
      )}
    </Skeleton>
  );
};
